import { round } from 'lodash';

let axios = require('axios');

/*
 * Card images
 *
 * Replace the background size of card images that are svg files.
 */
document.querySelectorAll('.card-image').forEach((cardImage) => {
    let extension = cardImage.style.backgroundImage.split(/[#?]/)[0].split('.').pop().trim();

    if (extension.includes('svg')) {
        cardImage.style.backgroundSize = 'contain';
    }
});

/*
 * Div toogles
 */
document.querySelectorAll('[data-btn-toogle]').forEach(element => {
    const target = element.getAttribute('data-btn-toogle');
    element.addEventListener('click', () => {
        document.querySelectorAll(`[data-div-toogle="${target}"]`).forEach(div => {
            div.classList.toggle('fade-in');
            div.classList.toggle('d-none');
        })
    })
});

/*
 * Confirm Action
 */
const showConfirmDialog = function (event) {

    let element = event.target;

    if (event.target.nodeName === "svg" || event.target.nodeName === "span") {
        element = element.parentElement;
    }

    if (event.target.nodeName === "path" || event.target.nodeName === "line" || event.target.nodeName === "polyline") {
        element = element.parentElement.parentElement;
    }

    const alertTitle = element.getAttribute('data-confirm-title');
    const alertDesc = element.getAttribute('data-confirm-desc');
    const alertButton = element.getAttribute('data-confirm-button');

    window.Swal.fire({
        title: alertTitle ? alertTitle : 'Tem Certeza?',
        text: alertDesc ? alertDesc : 'Essa ação não pode ser desfeita.',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: alertButton ? alertButton : 'Sim',
        cancelButtonText: 'Cancelar'
    }).then((result) => {
        if (result.isConfirmed) {
            element.removeEventListener('click', showConfirmDialog);
            element.setAttribute('type', 'submit');
            element.click();
        }
    });
}
document.querySelectorAll('[data-confirm-submition]').forEach(element => {
    element.addEventListener('click', showConfirmDialog);
});

/*
 * Dropdown select
 */
document.querySelectorAll('.dropdown-select .dropdown-item').forEach(item => {
    const selected = item.parentElement.parentElement.getElementsByClassName('dropdown-select-selected');
    const input = item.parentElement.parentElement.getElementsByTagName('input');
    const options = item.parentElement.querySelectorAll('.dropdown-item');

    if (item.classList.contains('selected')) {
        selected[0].innerHTML = item.innerHTML;
    }

    item.addEventListener('click', () => {
        selected[0].innerHTML = item.innerHTML;
        input[0].setAttribute('value', item.getAttribute('data-value'));

        options.forEach(option => option.classList.remove('selected'));
        item.classList.add('selected');
    })
});

/*
 * Inline select
 */
document.querySelectorAll('.inline-select .inline-select-item').forEach((item, index) => {
    const input = item.parentElement.parentElement.getElementsByTagName('input');
    const options = item.parentElement.querySelectorAll('.inline-select-item');
    const next = (typeof options[index + 1] === 'undefined') ? 0 : index + 1;

    item.addEventListener('click', () => {
        input[0].setAttribute('value', options[next].getAttribute('data-value'));

        item.classList.add('d-none');
        options[next].classList.remove('d-none');
    })
});

/*
 * Number input
 */
document.querySelectorAll('[data-number-input]').forEach(input => {
    input.addEventListener('blur', () => {
        if (!input.value.length || input.value === "0" || parseInt(input.value.replace('.', '')) < input.getAttribute('min')) {
            input.value = input.getAttribute('min');
        }

        if (input.getAttribute('max') && parseInt(input.value.replace('.', '')) > input.getAttribute('max')) {
            input.value = input.getAttribute('max');
        }
    })
});

/*
 * Bootstrap form validation
 * exemplo de como um button precisa ser:
 *  <button type="submit" class="btn btn-primary">
        <i data-feather="check" class="icon-md"></i>
        <div class="spinner-border spinner-border-sm me-1 d-none" role="status"></div>
        {{ __('Criar Evento') }}
    </button>
 */
document.querySelectorAll('.needs-validation').forEach((form) => {
    form.addEventListener('submit', (event) => {

        if (event.submitter.getAttribute('type') !== 'submit') {
            event.preventDefault();
            event.stopPropagation();
            return false;
        }

        if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
            form.classList.add('was-validated');
            return false;
        }

        form.classList.add('was-validated');

        const method = form.getAttribute('data-method');
        const inputs = form.querySelectorAll('[data-smart-input]');
        const button = form.querySelectorAll('button[type="submit"]')[0];

        button.getElementsByTagName('svg')[0].classList.add('d-none');
        button.getElementsByClassName('spinner-border')[0].classList.remove('d-none');

        let formData = new FormData(form);

        inputs.forEach(input => {

            input.classList.remove('is-invalid');

            let inputValue = input.value;

            if (input.hasAttribute('data-mask-money')) {
                inputValue = inputValue.replace('.', '').replace(',', '.');
            }

            if (input.hasAttribute('data-number-input') && !input.hasAttribute('data-integer-input')) {
                inputValue = parseFloat(inputValue);
            }

            if (input.hasAttribute('data-integer-input')) {
                inputValue = inputValue.replace('.', '').replace(',', '');
            }

            if (input.getAttribute('type') === 'checkbox') {
                inputValue = (input.checked) ? 1 : 0;
            }

            if (input.hasAttribute('data-base64encode')) {
                inputValue = window.btoa(`${inputValue}`);
            }

            if (input.getAttribute('type') !== 'file') {
                formData.set(input.getAttribute('name'), inputValue);
            }

        });

        axios[method](form.getAttribute('action'), formData)
            .then(function (response) {

                if (response.status === 200) {

                    if (response.data.message) {
                        window.toastr[response.data.message.type](response.data.message.text);
                    }

                    if (response.data.redirect) {
                        let delay = 0;
                        if (response.data.delay) {
                            delay = response.data.delay;
                        }
                        setTimeout(function() {
                            window.location.href = response.data.redirect;
                        }, delay);
                    }

                } else if (response.data.error) {

                    window.toastr.error(response.data.error);

                }

                button.getElementsByTagName('svg')[0].classList.remove('d-none');
                button.getElementsByClassName('spinner-border')[0].classList.add('d-none');

                form.classList.remove('was-validated');


            })
            .catch(function (error) {

                form.classList.remove('was-validated');

                if (error.response.data.message) {
                    window.toastr.error(error.response.data.message);

                    if (error.response.data.errors) {
                        Object.entries(error.response.data.errors).forEach(([field, message]) => {
                            form.querySelectorAll(`[name="${field}"]`)[0].classList.add('is-invalid');
                        });
                    }

                }

                button.getElementsByTagName('svg')[0].classList.remove('d-none');
                button.getElementsByClassName('spinner-border')[0].classList.add('d-none');
            });


        event.preventDefault();
    }, false)
});

export function showShippingOptions(shipping_data) {
    // Should do the shipping calc logic here
    if (shipping_data) {
        $("#checkout-shipping").html(shipping_data).fadeIn();
    } else {
        $("#checkout-shipping").html('').fadeOut();
    }
}

export function saveInstallments(installments) {
    if (installments) {
        window.installments = installments;
    }
}

export function checkShippingOptionForCoupon() {
    let expressShippingOption = document.querySelector('#checkout-shipping .shipping-options li[data-shipping-type="express"]');

    if (expressShippingOption) {
        expressShippingOption.click();
    } else {
        document.querySelector('#checkout-shipping .shipping-options li[data-shipping-type="' + window.selectedShippingTypeBackup + '"]')?.click();
    }
}

/**
 * Returns active shipping option
 *
 * @returns {boolean|*}
 */
export function getShippingOption() {
    if (Array.from(document.querySelectorAll("#checkout-shipping")).length) {
        return window.jQuery('.shipping-options li[data-active="true"]').data("shipping-type");
    } else {
        return true;
    }
}

/**
 * Returns selected shipping price
 *
 * @returns {boolean|*}
 */
export function getShippingPrice() {
    if (window.jQuery('#checkout-shipping')) {
        return window.jQuery('.shipping-options li[data-active="true"]').data("shipping-price");
    } else {
        return 0;
    }
}

export function updatePriceValuesOnStep2(installments) {
    //Selected installments for detail
    if(installments){
        window.finalInstallments = installments;
    }else {
        installments = window.finalInstallments;
    }
    // console.log('installments', installments);
    // console.log('keys', Object.keys(installments));

    let options = '';
    let interest_free = $("#cc_installments").data("interest-free");
    let count = 1;
    const total = Object.keys(installments).length;

    for (let prop in installments) {
        if (installments.hasOwnProperty(prop)) {
            let asterisk = (prop > interest_free) ? "*" : "";

            let selected = (count === total) ? 'selected' : ''; //Ultimo parcelamento
            if (selected_installment < total) { //Aplica o parcelamento configurado, se existir
                selected = (count == selected_installment) ? 'selected' : '';
            }

            options += `<option value="${prop}" ${selected}>${prop}x de R$ ${installments[prop]} ${asterisk}</option>`;
            count++;
        }
    }

    // Credit card installments
    $('#cc_installments').html(options);

    // Billet total value
    $('.order-total-value').html(installments[1]);

    // Shipping price
    let shipping_price = getShippingPrice();
    // console.log('shipping_price', shipping_price);
    if (shipping_price !== undefined && shipping_price > 0) {
        $('#shipping-value-line').removeClass('d-none');
        $('.shipping-value').html(`${getShippingPrice()}`.replace('.', ','));
    } else {
        $('#shipping-value-line').addClass('d-none');
        $('.shipping-value').html('');
    }

    //Cart Details
    const selectObject = document.getElementById('cc_installments');
    let productName = '';
    let discount = (window.coupon && window.coupon.type.startsWith('VALUE')) ?
        ('R$ ' + window.coupon.value + ' de desconto') :
        (
            (window.coupon && window.coupon.type.startsWith('PERCENT')) ?
                (window.coupon.value + '% de desconto') : 
                ''
        );
    discount = discount ? '<small class="px-2" style="color: #006927; background-color: #cef9de; font-weight: 700; border-radius: 0.625rem;">' + discount + '</small>' : '';
    
    if (product_type == 'PHYSICAL') {
        if (shipping_price == 0) {
            productName = product_name + " + Frete Grátis";
        } else {
            productName = product_name + " + Frete";
        }
    } else {
        productName = product_name;
    }

    productDetailsHtml(
        productName,
        product_link_id,
        selectObject.value,
        window.finalInstallments[selectObject.value],
        payment_type,
        product_period || null,
        product_period_type || null,
        true,
        discount
    );

    // Coupon discount
    if (window.coupon) {
        $('#coupon-line').removeClass('d-none');
        let type = window.coupon.type.startsWith('VALUE') ? ('R$ ' + window.coupon.value) : (window.coupon.value + '%');
        $('#coupon-line-description').html(type + ' de desconto');
        let product_price = $('#product-price').html().replace(',', '.');
        let discount_value = (window.coupon.type.startsWith('VALUE')) ?
            window.coupon.value :
            product_price * (window.coupon.value / 100);
        $('#coupon-line-value').html(discount_value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
    } else {
        $('#coupon-line').addClass('d-none');
        $('#coupon-line-description').html('');
        $('#coupon-line-value').html('');
    }
}

/**
 * Function to create product details html
 * @param {string} productName
 * @param {string} productLinkId
 * @param {string} productInstallments
 * @param {string} productInstallments_value
 * */
export function productDetailsHtml(productName, productLinkId, productInstallments, productInstallments_value, paymentType, productPeriod = null, productPeriodType = null, updateAllLineInformation = false, discount = false) {
    let detailsDivs = document.querySelectorAll('.details_row');
    detailsDivs.forEach( (detailsDiv) => {
        let period = getPeriod(productPeriodType, productPeriod);

        if (detailsDiv.children.length > 0) {
            for (let i = 0; i < detailsDiv.children.length; i++) {
                const element = detailsDiv.children[i];
                if (element.dataset.pl_id == productLinkId){
                    
                    if (paymentType == 'SUBSCRIPTION'){
                        element.children[0].children[1].innerHTML = "<p class='mb-0'>" + (discount ? discount + ' ' : '') + productInstallments +"x de R$ "+ productInstallments_value + "<br> <span style='font-size:9pt;'>a cada " + productPeriod + " " + period + "</span></p>";
                    } else {
                        element.children[0].children[1].innerHTML = "<p class='mb-0'>" + (discount ? discount + ' ' : '') +  productInstallments + "x de R$ "+ productInstallments_value + "</p>";
                    }

                    if (updateAllLineInformation) {
                        element.children[0].children[0].innerHTML = "<p class='mb-0'><b>" + productName + "</b></p>";
                    }

                    return;
                }
            }
        }

        
        const card_round = document.createElement('div');
        card_round.classList.add('border', 'rounded', 'px-2', 'py-3', 'mb-2');
        card_round.dataset.pl_id = productLinkId;

        const row = document.createElement('div');
        row.classList.add('row', 'align-items-center');

        const col_1 = document.createElement('div');
        col_1.classList.add('col-7', 'text-start');
        col_1.innerHTML = "<p class='mb-0'><b>" + productName + "</b></p>";

        const col_2 = document.createElement('div');
        col_2.classList.add('col-5', 'text-end');
        
        if(paymentType == 'SUBSCRIPTION'){
            col_2.innerHTML = "<p class='mb-0'>" + productInstallments +"x de R$ "+ productInstallments_value + "<br> <span style='font-size:9pt;'>a cada " + productPeriod + " " + period + "</span></p>";
        }else{
            col_2.innerHTML = "<p class='mb-0'>" + productInstallments +"x de R$ "+ productInstallments_value + "</p>";
        }

        row.appendChild(col_1);
        row.appendChild(col_2);
        card_round.appendChild(row);
        detailsDiv.appendChild(card_round);

        const messageDetail = document.getElementById('message_detail');
        if(detailsDiv.children.length > 1){
            messageDetail.classList.remove('message_details-hidden');
            messageDetail.classList.add('message_details');
        }else{
            messageDetail.classList.remove('message_details');
            messageDetail.classList.add('message_details-hidden');
        }
    });
}

function getPeriod(periodType, period) {
    let periodText = '';
    switch (periodType) {
        case 'DAY':
            periodText = (period > 1) ? 'dias' : 'dia';
            break;
        case 'MONTH':
            periodText = (period > 1) ? 'meses' : 'mês';
            break;
        case 'YEAR':
            periodText = (period > 1) ? 'anos' : 'ano';
            break;
        default:
            periodText = '';
            break;
    }
    return periodText;
}

// Function to generate billet and send events to Facebook and GA
export async function generateBillet(target) {
    let button = target;
    $(button).find("svg").hide();

    $(button).find("span").fadeIn("slow");
    $(button).attr("disabled", "true");

    $('body').append(custom_scripts_facebook.add_payment_info_browser);
    // $('body').append(custom_scripts_facebook.add_payment_info_api);
    window.addPaymentInfoEvents()

    if(enable_analytics == 1){
        if(gtag_click_buy == false){
            waitForGtag(function() {
                gtag('event', 'add_payment_info', {
                    "items": gtag_items,
                    "checkout_option": 'BILLET', //CREDIT_CARD, BILLET, PIX
                    "checkout_step": (gtag_hasCep == true) ? 4 : 3,
                });
            });
            gtag_click_buy = true;
        }
    }

    if(products_fb){
        let fb_track_currency = 'BRL';
        products_fb.forEach(function(product_facebook) {
            fb_track_currency = product_facebook.currency
            if(product_facebook.enable_browser){
                if(product_facebook.track_customs){
                    product_facebook.track_customs.forEach(element => {

                        if( element.event == 'AddPaymentInfo' ){

                            const track_name = element.name;

                            if(element.value){
                                const track_value = element.value;
                                fbq('trackCustom', `${track_name}`, {value: track_value, currency: fb_track_currency}, {eventID: fb_product_id });
                            }else{
                                fbq('trackCustom', track_name, {eventID: fb_product_id });
                            }
                        }

                    });
                }

            }
        });
    }

    await window.postOrder('billet', '', '', button);

    $(button).find("span").hide();
    $(button).find("svg").fadeIn("slow");

}

function discountGetShippingPrice() {
    if (window.jQuery('#checkout-shipping')) {
        return window.jQuery('.shipping-options li[data-active="true"]').data("shipping-price");
    } else {
        return 0;
    }
}

export function changePixValue(value = null){
    let newValueCartDetail = value;
    if(newValueCartDetail == null){
        console.log(newValueCartDetail)
        if(window.discount_installment == null){
            console.log("all null")
            return;
        }
        newValueCartDetail = window.discount_installment;
    } 

    newValueCartDetail += ' <small class="px-1 bg-success text-light">' + window.pix_discount + '% de desconto</small>';
    let pixValuePlaceholdersCartDetails = document.querySelectorAll('.cart_details');
    pixValuePlaceholdersCartDetails.forEach( (placeHolder) => { 

        const detailRow = placeHolder.children[1].children[0];

        if (detailRow.children.length > 0) {
            for (let i = 0; i < detailRow.children.length; i++) {
                detailRow.children[i].children[1].children[0].innerHTML = "1x de R$ " + newValueCartDetail;
            }
        }

    } );
}

export async function askAboutPixDiscount(clickEvent) {
    window.Swal.fire({
        title: 'Você ganhou ' + window.pix_discount + '% de desconto no PIX!',
        html: 'Benefício válido por tempo limitado',
        icon: 'success',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Pagar com Pix',
        cancelButtonText: 'Gerar Boleto'
    }).then((result) => {
        // Se confirmado, aplica o desconto e recarrega os valores do Pix
        if (result.isConfirmed) {
            window.pix_discount_applied = true;
            // chamada para RECALCULAR VALORES NOVOS do Pix de acordo com o desconto
            axios.post(`/api/order/installments/${cart_hash}`, { shipping_value: discountGetShippingPrice(), pix_discount_applied: window.pix_discount_applied })
                .then( (response) => {
                    if (response.data.installments) {
                        window.discount_installment = response.data.installments[1]
                        let newValue = window.discount_installment;
                        newValue += ' <small class="px-1 bg-success text-light">' + window.pix_discount + '% de desconto</small>';
                        let pixValuePlaceholders = document.querySelectorAll('#pix-toggle-body .order-total-value');
                        pixValuePlaceholders.forEach( (placeHolder) => { placeHolder.innerHTML = newValue; } );
                        
                        changePixValue(response.data.installments[1]);
                        
                    }
                });
            var toggleElement = document.querySelector('[data-cp-toggle="pix-toggle-body"]');
            toggleElement.click();
        // Ou então, gera o boleto direto ao cancelar
        } else if(result.dismiss == 'cancel'){
            window.pix_discount_applied = false;
            let button = document.getElementById('generate-billet');
            generateBillet(button);
        }
    });
}


export async function askAboutPixDiscountOnEloCard() {
     window.Swal.fire({
            title: 'Você ganhou ' + window.pix_discount + '% de desconto no PIX!',
            html: 'Benefício válido por tempo limitado',
            icon: 'success',
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: 'Pagar com Pix',
            cancelButtonText: 'Continuar com o Cartão'
        }).then((result) => {
            // Se confirmado, aplica o desconto e recarrega os valores do Pix
            if (result.isConfirmed) {
                window.pix_discount_applied = true;
                // chamada para RECALCULAR VALORES NOVOS do Pix de acordo com o desconto
                axios.post(`/api/order/installments/${cart_hash}`, { shipping_value: discountGetShippingPrice(), pix_discount_applied: window.pix_discount_applied })
                    .then( (response) => {
                        if (response.data.installments) {
                            window.discount_installment = response.data.installments[1]
                            let newValue = window.discount_installment;
                            newValue += ' <small class="px-1 bg-success text-light">' + window.pix_discount + '% de desconto</small>';
                            let pixValuePlaceholders = document.querySelectorAll('#pix-toggle-body .order-total-value');
                            pixValuePlaceholders.forEach( (placeHolder) => { placeHolder.innerHTML = newValue; } );
                            
                            changePixValue(response.data.installments[1]);
                            
                        }
                    });
                var toggleElement = document.querySelector('[data-cp-toggle="pix-toggle-body"]');
                toggleElement.click();
            } 
        });
}

/**
 * Enable tooltips everywhere
 */
let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
})

/**
 * Enable popovers everywhere
 */
let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
let popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl)
})
